const asyncOrgRoutes = {
  path: 'org/list',
  component: () => import('@/views/system/org/index'),
  funcPerms: 'system:setting:org',
  name: 'auth-org',
  meta: {
    title: '部门管理',
    // icon: 'el-icon-user',
    icon: 'index',
    affix: false,
    noCache: true
  }
}

export default asyncOrgRoutes
